import Transactions from "../components/Transactions/Transactions";
import ImpactHeader from "../components/header/ImpactHeader";
import SideBar from "../components/sidebar/Sidebar";


export default function TransactionsList ({ rows }) {

    return (
        <div>
            <SideBar />
            <ImpactHeader />
            <div className="impact-main-app-content">
                <Transactions />
            </div>
        </div>

    )
}